"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var Payment = /*#__PURE__*/function () {
  function Payment(client) {
    (0, _classCallCheck2["default"])(this, Payment);
    this.client = client;
    this.resourceUrl = '/admin';
  }

  (0, _createClass2["default"])(Payment, [{
    key: "getUserPaymentInformation",
    value: function getUserPaymentInformation(data) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return this.client.post("".concat(this.resourceUrl, "/payment"), data, args);
    }
  }, {
    key: "getSubscriptionPayment",
    value: function getSubscriptionPayment(data) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return this.client.post("".concat(this.resourceUrl, "/sow-subscriptions"), data, args);
    }
  }, {
    key: "getSowPayments",
    value: function getSowPayments(data) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      return this.client.post("".concat(this.resourceUrl, "/sow-payments"), data, args);
    }
  }, {
    key: "exportPaymentUsersCSV",
    value: function exportPaymentUsersCSV(data) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      return this.client.post("".concat(this.resourceUrl, "/export-payment-csv"), data, args);
    }
  }]);
  return Payment;
}();

exports["default"] = Payment;